import { Alert, Button, Group, Stack, TextInput } from "@mantine/core"
import { observer } from "mobx-react-lite"
import { Link, useNavigate, useParams } from "react-router-dom"
import { BannerStore } from "../../../app/store"
import { useForm, yupResolver } from "@mantine/form"
import { type BannerRequest } from "../../../shared/types/banner"
import { useEffect } from "react"
import { PATHS } from "../../../shared/lib/paths"
import { ImageDropzone } from "../../../shared/ui/ImageDropzone"
import { IconAlertCircle } from "@tabler/icons-react"
import { validationSchema } from "./config"

// ----------------------------------------------------------------------

export const BannerEditForm = observer(function BannerEditForm() {
  const navigate = useNavigate()
  const { bannerId } = useParams<{ bannerId?: string }>()

  const {
    createBanner,
    updateBanner,
    getBanner,
    error,
    isLoading,
  } = BannerStore

  const form = useForm<BannerRequest>({
    validateInputOnChange: true,
    validate: yupResolver(validationSchema),
    initialValues: {
      name: "",
      image: "",
      url: "",
    },
  })

  useEffect(() => {
    if (bannerId) {
      void getBanner(bannerId).then((banner) => {
        if (banner) {
          const { name, image, url } = banner

          form.setValues({ name, image, url })
          form.resetDirty({ name, image, url })
        }
      })
    }

    return () => {
      form.reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ bannerId ])

  const onSubmit = (values: typeof form.values) => {
    const formData = new FormData()

    Object.entries(values).forEach(([ key, value ]) => {
      if (bannerId && form.isDirty(key) || !bannerId) {
        formData.append(key, value)
      }
    })

    if (bannerId) {
      void updateBanner(bannerId, formData).then(success => {
        if (success) {
          navigate(PATHS.DASHBOARD.BANNERS.ROOT)
        }
      })
    } else {
      void createBanner(formData).then(success => {
        if (success) {
          navigate(PATHS.DASHBOARD.BANNERS.ROOT)
        }
      })
    }
  }

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack spacing="xl">
        <TextInput label="Название баннера" placeholder="Курс нутрициологии" {...form.getInputProps("name")} />

        <TextInput
          label="Ссылка для перехода"
          placeholder="https://your-link.ru/href"
          {...form.getInputProps("url")}
        />

        <ImageDropzone formValues={form.getInputProps("image")}/>
      </Stack>

      {error && (
        <Alert mt="xl" icon={<IconAlertCircle size="1rem"/>} title="Произошла ошибка" color="red">
          {error}
        </Alert>
      )}

      <Group position="center" my="xl">
        <Button disabled={!form.isDirty() || !form.isValid()} type="submit">
          {bannerId ? "Обновить" : "Создать"}
        </Button>
        <Button disabled={isLoading} variant="light" color="gray" component={Link} to={PATHS.DASHBOARD.BANNERS.ROOT}>
          Назад
        </Button>
      </Group>
    </form>
  )
})
